import { DarwinCol, DarwinRow } from 'components/darwin-ui';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputType } from 'types/genericTypes';
import {
  CreateProcessMapPayload,
  ProcessesMapsInputProps,
} from 'types/processesTypes';
import { GenericInput } from '../GenericInput';

interface MetaDataProcessMapProps {
  control: Control<CreateProcessMapPayload>;
  errors: FieldErrors<CreateProcessMapPayload>;
}

export const MetaDataProcessMap = ({
  control,
  errors,
}: MetaDataProcessMapProps) => {
  const { t } = useTranslation();
  const column: ProcessesMapsInputProps = [
    {
      inputType: InputType.INPUT,
      fieldName: 'createdBy',
      label: t('process-map.new-process-map.createdBy'),
      inputRules: {},
      disabled: true,
    },
    {
      inputType: InputType.DATEPICKER,
      fieldName: 'createdAt',
      label: t('process-map.new-process-map.createdAt'),
      inputRules: {},
      disabled: true,
    },
    {
      inputType: InputType.DATEPICKER,
      fieldName: 'updatedAt',
      label: t('process-map.new-process-map.updatedAt'),
      inputRules: {},
      disabled: true,
    },
  ];
  return (
    <>
      <DarwinRow style={{ marginTop: 16 }} gutter={16}>
        <DarwinCol span={12}>
          {column.map(input => (
            <GenericInput
              key={input.fieldName}
              control={control}
              errors={errors}
              {...input}
            />
          ))}
        </DarwinCol>
      </DarwinRow>
    </>
  );
};
